export default "__VITE_ASSET__CM$3b_P6__"